import React from 'react';
import { QuizStep } from '../../lib/quiz-definition';

interface CheckoutStepProps {
    step: QuizStep;
    // Removed onBack
    // Add props for Stripe integration later
}

const CheckoutStep: React.FC<CheckoutStepProps> = ({ step }) => {
    return (
        <div className="quiz-step checkout-step">
             <h2>Checkout</h2>
            <p>{step.content}</p>
            {/* Stripe Elements or redirect logic will go here */}
            <div>Stripe Integration Placeholder</div>
        </div>
    );
};

export default CheckoutStep; 